import { ArgusUtils, type IEnvConfig } from "@mnemonic/pure-utils";

export const initializeTarget = (): IEnvConfig => ArgusUtils.getTargetMeta();
